import { load } from 'cheerio';

export function extractIOCategoryDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    return (
        $('.io_cat_description, .catDescriptionIO, .cat_div_wrapper, .io_cat_longdescription')
            .first()
            .html() || ''
    );
}
